import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../../store';
import SucursalUpsertForm from './SucursalUpsertForm';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import PageHeader from '../../../support/page-header/PageHeader';
import ResponseError from '../../../shared/responses/ResponseError';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../../shared/responses/ResponseResult';

class SucursalUpsert extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      ...this.state,
      data: !!data.id ? { ...data } : { id },
    };

    props.reset();
    props.setData({ ...data });
  }

  handleSubmit = async (action, info) => {
    const { data } = this.props;
    const body = {
      sucursales: { ...[data] },
    };

    this.props.upsert(body, data.id);
  };

  handleOnFormDataChange = (event) => {
    this.props.change(event);
  };

  renderError = () => {
    const { error } = this.props;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props;

    return (
      <div className="result-container">
        <ResponseResult
          title="Registrado"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.resetError({
        error: undefined,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    const { result } = this.props;

    if (!!result) {
      this.props.highlight(result);
    }

    this.props.history.replace('/cuenta/sucursal');
  };

  render() {
    const { data, error, result, isValid, busy, fetching } = this.props;

    if (fetching) {
      return <Loading />;
    }

    return (
      <>
        <PageHeader
          to="/cuenta/sucursal"
          text="Sucursales"
        />

        <h5>Nueva sucursal</h5>

        <SucursalUpsertForm
          data={data}
          onFormDataChange={this.handleOnFormDataChange}
        />

        {!!error && this.renderError()}

        {!!result && this.renderResult()}

        <Row className="pb-5">
          <Col>
            <PopConfirm
              text="Quieres cancelar el registro actual?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
                className="mr-3"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy}
              onClick={this.handleSubmit}
            >
              {!!data.id ? (busy ? 'Guardando...' : 'Guardar') : ''}
              {!data.id ? (busy ? 'Registrando...' : 'Registrar') : ''}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (state) => {
  return {
    ...state.cuenta.sucursal.upsert,
  };
};

const mapActions = (actions) => {
  return {
    ...actions.cuenta.sucursal.upsert,
    highlight: actions.cuenta.sucursal.list.highlight,
  };
};

export default connect(useStore, mapState, mapActions)(SucursalUpsert);
